<div class="d-flex align-items-center justify-content-between">
    <h2 mat-dialog-title>{{ title }}</h2>
    <button mat-icon-button mat-dialog-close class="d-flex justify-content-center m-r-10">
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
    </button>
</div>
<mat-dialog-content>
    <form [formGroup]="ReportForm">
        <div class="row" *ngIf="!isDoctor">
            <div class="col-lg-12">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.DOCTORS' | translate }}</mat-label>
                    <input type="text" matInput placeholder="Search doctors" [formControl]="doctorControls"
                        [matAutocomplete]="doctorAuto" />
                    <mat-autocomplete #doctorAuto="matAutocomplete">
                        <mat-option *ngFor="let doc of filteredDoctorList$ | async" [value]="doc"
                            (onSelectionChange)="onDoctorToggle(doc)">
                            <mat-checkbox [checked]="isDoctorSelected(doc.id)" (change)="onDoctorToggle(doc)"
                                (click)="$event.stopPropagation()">
                                {{ doc.name }}
                            </mat-checkbox>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.START_DATE' | translate }}</mat-label>
                    <input matInput [matDatepicker]="startPicker" required placeholder="Date"
                        formControlName="startDate" [min]="minDate" [max]="maxDate" readonly>
                    <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startPicker [color]="'primary'"></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ 'LABEL.END_DATE' | translate }}</mat-label>
                    <input matInput [matDatepicker]="endPicker" required placeholder="Date" formControlName="endDate"
                        [min]="minDate" [max]="maxDate" readonly>
                    <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker [color]="'primary'"></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row p-r-16">
        <div class="col-lg-8"></div>
        <div class="col-lg-4 d-flex justify-content-end">
            <button mat-stroked-button class="m-r-5" (click)="onCloseDialog()">{{ 'BUTTON.BTN_CLOSE' | translate
                }}</button>
            <!-- <button mat-flat-button color="primary" class=" m-l-4" (click)="PrintReport()"
                [disabled]="ReportForm.invalid">
                {{ 'BUTTON.BTN_PRINT' | translate }}</button> -->
        </div>
    </div>
</mat-dialog-actions>